import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Manrope, sans-serif',
  },
});

export default theme;
